import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'react-notifications/lib/notifications.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App/>, document.getElementById('root'));
// Service Workers sound cool but break everything when your client and api are hosted together on the same port.
// registerServiceWorker();
